// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2lZT9","col":"Table_col__2cAMt","fulfillmentStatus":"Table_fulfillmentStatus__13dcq","emailCol":"Table_emailCol__1dKIZ"};